export const checkPassValidator = (password) => {
  if (password.length < 8) {
    return "Password must be atleast 8 characters long";
  }

  let regex;
  regex = /^(?=.*[a-z]).+$/;
  if (!regex.test(password)) {
    return "Password must contain a lowercase character";
  }

  regex = /^(?=.*[A-Z]).+$/; // Uppercase character pattern

  if (!regex.test(password)) {
    return "Password must contain a uppercase character";
  }

  regex = /[0-9]/;

  if (!regex.test(password)) {
    return "Password must contain a number";
  }
  regex = /^[\w&.\-]+$/; // Special character or number pattern

  if (regex.test(password)) {
    return "Password must contain a special character";
  }

  return "Success";
};
